import { Nullable } from 'common-types';
import { getActiveMembers } from '../../members/api/members-api';
import { openSnackbar } from '../../snackbar/actions/snackbar-actions';
import notificationService from '../services';
import {
  NotificationError,
  NotificationChannelType,
  Recipient,
  NotificationType,
} from '../types/notification-settings-types';
import {
  setIsLoadingTestNotification,
  setPotentialRecipients,
} from '../utils/notification-configure-store-utils';
import {
  clearErrorMessage,
  setNotifications,
  setErrorMessage,
  setLoadingNotifications,
  setNotification,
} from '../utils/notification-store-utils';

export const loadNotificationSettings = async (): Promise<void> => {
  try {
    setLoadingNotifications(true);
    clearErrorMessage();

    const notificationsSettings =
      await notificationService.getNotificationSettings.execute();
    if (!notificationsSettings) {
      setErrorMessage(NotificationError.FailedLoadNotificationSettings);
      return;
    }

    const activeMembers = await getActiveMembers();
    if (activeMembers) {
      setPotentialRecipients(activeMembers as Recipient[]);
    }

    setNotifications(notificationsSettings);
  } finally {
    setLoadingNotifications(false);
  }
};

export const toggleNotification = async (
  notificationChannelType: NotificationChannelType,
  enabled: boolean,
): Promise<void> => {
  const updatedNotificationSettings =
    await notificationService.toggleNotification.execute(
      notificationChannelType,
      !enabled,
    );

  if (!updatedNotificationSettings) {
    return;
  }

  setNotification(updatedNotificationSettings);
};

export const updateNotification = async (
  notificationChannelType: NotificationChannelType,
  recipients: Nullable<Recipient[]>,
  notifyAll: Nullable<boolean>,
): Promise<void> => {
  const updatedNotificationSettings =
    await notificationService.updateNotification.execute(
      notificationChannelType,
      recipients,
      notifyAll,
    );

  if (!updatedNotificationSettings) {
    return;
  }

  setNotification(updatedNotificationSettings);
};

export const sendTestNotification = async (
  notificationChannelType: NotificationChannelType,
): Promise<void> => {
  setIsLoadingTestNotification(true);
  openSnackbar('Sending test Email', {
    variant: 'default',
  });

  const sentSuccessfully = await notificationService.sendNotification.execute(
    notificationChannelType,
    NotificationType.TestNotification,
  );

  if (sentSuccessfully) {
    openSnackbar('Test email sent successfully', {
      variant: 'success',
    });
  } else {
    openSnackbar('Failed to send test Email', {
      variant: 'error',
    });
  }

  setIsLoadingTestNotification(false);
};

export const toggleNotificationForMe = async (
  notificationChannelType: NotificationChannelType,
  enabled: boolean,
): Promise<void> => {
  const updatedNotificationSettings =
    await notificationService.toggleNotificationForMe.execute(
      notificationChannelType,
      !enabled,
    );

  if (!updatedNotificationSettings) {
    return;
  }

  setNotification(updatedNotificationSettings);
};
